/* eslint-disable arrow-parens */
<!--
 * @Author: your name
 * @Date: 2021-11-09 15:03:04
 * @LastEditTime: 2021-11-09 17:29:42
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/pages/personalCenter/myHandsel/handselDetail.vue
-->
<template>
  <div :class="['myHandsel', { inApp: $root.$data.isApp }]">
    <common-title titleName="定金详情" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div
      class="handsel-detail"
      :class="{ deposit: handselDetail.status === 4 }"
      v-if="handselDetail.createTime"
    >
      <h1 class="type-name">{{ showTitle(handselDetail.status) }}</h1>
      <TimerCount v-if="show" showType="1" :handselInfo="handselDetail" @updateInfo="updateInfo" />
      <div class="course-list">
        <div v-if="handselDetail.packageProductList">
          <div
            class="packageProductList"
            v-for="(item, index) in handselDetail.packageProductList"
            :key="index"
          >
            <h1>{{ item.packageName }}</h1>
            <p>包含以下课程:</p>
            <CourseList :courseList="item.orderProductVOList" />
          </div>
        </div>
        <div v-else><CourseList :courseList="handselDetail.productVOList" /></div>
      </div>
      <div class="price-info">
        <p>
          <span>总计</span><b>¥{{ handselDetail.sellAmount }}</b>
        </p>
        <p>
          <span>优惠金额</span><b>-¥{{ handselDetail.discountAmount }}</b>
        </p>
        <p>
          <span>应付</span><b class="active">¥{{ handselDetail.orderAmount }}</b>
        </p>
      </div>
      <div class="pay-flow" v-if="show">
        <h3>支付流程</h3>
        <div class="time-flow">
          <div class="time-flow-box">
            <div class="icon"></div>
            <span
              >定金<b>（{{ handselDetail.status === 4 ? '支付完成' : '待支付' }}）</b></span
            >
            <div class="order-time" v-if="handselDetail.depositPayTime">
              <span>{{ handselDetail.depositPayTime.slice(0, 16) }}</span>
              <b v-if="filterPaymentType(handselDetail.depositPaymentType)"
                >{{ filterPaymentType(handselDetail.depositPaymentType) }}</b
              >
            </div>
          </div>
          <b>¥{{ handselDetail.depositAmount }}</b>
        </div>
        <div class="time-flow1">
          <div class="time-flow-box">
            <div class="icon"></div>
            <span
              >尾款 <b>（{{ handselDetail.status === 5 ? '支付完成' : '待支付' }}）</b></span
            >
          </div>
          <b>¥{{ handselDetail.balanceAmount }}</b>
        </div>
      </div>
      <div class="order-info">
        <div class="order-code">
          <span>定金单号</span>
          <div>
            <b>{{ handselDetail.depositOrderNo }}</b
            ><img @click="orderNoCopy" src="@/assets/img/personalCenter/copy.png" alt="复制" />
          </div>
        </div>
        <div class="order-code">
          <span>下单时间</span>
          <b>{{ handselDetail.createTime.slice(0, 16) }}</b>
        </div>
      </div>
      <div class="btns" v-if="show">
        <div class="btns-box">
          <button class="cancel" @click="cancelOrder" v-if="handselDetail.status === 1">
            取消订单
          </button>
          <button
            class="pay"
            @click="toPay"
            v-if="handselDetail.status === 1 || handselDetail.status === 4"
          >
            立即支付
          </button>
        </div>
      </div>
    </div>
    <UserHandsel v-if="showError" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import wx from 'weixin-js-sdk';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { copyTool } from '@/utils/tools';
import { reqDepositDetail, reqCancelDeposit } from '@/api/personal/handsel';
import { paymentType } from '@/pages/personalCenter/myIndent/indentTools';
import UserHandsel from './components/userHandsel.vue';
import TimerCount from './components/timerCount.vue';
import CourseList from './components/courseList.vue';

export default {
  components: {
    CommonTitle,
    TimerCount,
    UserHandsel,
    CourseList,
  },
  data() {
    return {
      handselDetail: {},
      show: false,
      showError: false,
    };
  },
  computed: {
    ...mapState(['currentTime']),
  },
  watch: {},
  methods: {
    async getDetail() {
      const currentTime = await this.$root.getServerTime();
      const { handselOrder } = this.$route.query;
      const { msg, data, code } = await reqDepositDetail(handselOrder);
      if (code === 0 && data) {
        this.handselDetail = data;
      } else {
        this.$toast(msg);
      }
      if (code === 3505) {
        this.showError = true;
        return;
      }
      const {
        status, depositOverTime, balanceOverTime, productVOList, packageProductList,
      } = data;
      // eslint-disable-next-line no-unused-expressions
      packageProductList?.forEach((item) => {
        item.orderProductVOList.forEach((element) => {
          const skuname = JSON.parse(element.skuName);
          const name = skuname.map((sku) => sku.value).toString();
          Object.assign(element, { _skuname: name === '单品' ? '' : name });
        });
      });
      productVOList.forEach((element) => {
        const skuname = JSON.parse(element.skuName);
        const name = skuname.map((sku) => sku.value).toString();
        Object.assign(element, { _skuname: name === '单品' ? '' : name });
      });
      if (status === 1) {
        this.show = true;
        Object.assign(data, { _endTime: moment(depositOverTime).valueOf() });
      } else if (status === 4) {
        Object.assign(data, { _endTime: moment(balanceOverTime).valueOf() });
        this.show = true;
      }
      Object.assign(data, { currentTime: moment(currentTime).valueOf() });
      this.handselDetail = data;
    },
    updateInfo() {
      this.show = false;
      this.getDetail();
    },
    // 取消定金
    async cancelOrder() {
      this.$dialog
        .confirm({
          // title: '提示',
          message: '确认取消定金单吗？',
          confirmButtonText: '确定',
        })
        .then(async () => {
          const { depositOrderNo } = this.handselDetail;
          const res = await reqCancelDeposit(depositOrderNo);
          const { code, msg } = res;
          if (code === 0) {
            this.$toast('取消成功');
            setTimeout(() => {
              this.$router.push({
                path: '/personalCenter/myHandsel',
              });
            }, 1000);
          } else {
            this.$toast(msg);
          }
        })
        .catch(() => {});
    },
    orderNoCopy() {
      copyTool(this.handselDetail.depositOrderNo)
        .then(() => {
          this.$toast('复制成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    toPay() {
      const { depositOrderNo, status } = this.handselDetail;
      if (this.$root.$data.isApp) {
        const param = {
          orderNo: depositOrderNo,
          type: status === 1 ? 3 : 4,
        };
        this.$sendToApp('payCenter', param, false);
      } else {
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({
            url: `/myCourse/cashier/cashier?orderNo=${depositOrderNo}&source=${
              status === 1 ? 3 : 4
            }`,
          });
          return;
        }
        this.$router.replace({
          path: '/cashier',
          query: {
            orderNo: depositOrderNo,
            source: status === 1 ? 3 : 4,
          },
        });
      }
    },
    showTitle(status) {
      let statusText = '';
      switch (status) {
        case 1:
          statusText = '等待支付定金';
          break;
        case 2:
          statusText = '定金关闭';
          break;
        case 3:
          statusText = '定金超时关闭';
          break;
        case 4:
          statusText = '等待支付尾款';
          break;
        case 5:
          statusText = '尾款已支付';
          break;
        case 6:
          statusText = '尾款超时关闭';
          break;
        // eslint-disable-next-line no-fallthrough
        default:
      }
      return statusText;
    },
    // 判断支付方式类型
    filterPaymentType(status) {
      return paymentType(status);
    },
  },
  created() {
    this.getDetail();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.myHandsel {
  padding: 140px 36px 90px 36px;
  &.inApp {
    padding-top: 30px;
    padding-bottom: 90px;
  }
  .type-name {
    padding-bottom: 18px;
    color: #ff6c02;
    font-weight: 500;
    font-size: 43px;
  }
  .course-list {
    margin: 22px 0;
    padding: 19px 36px;
    background: #fff;
    border-radius: 14px;
    .packageProductList {
      > h1 {
        padding-bottom: 15px;
        color: #333;
        font-weight: 600;
        font-size: 33px;
        line-height: 40px;
      }
      > p {
         padding: 0 0 10px 0;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 40px;

      }
    }
  }
}
.price-info {
  width: 100%;
  padding: 29px 36px 0 36px;
  background: #fff;
  border-radius: 14px;
  p {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 29px;
    span {
      color: #333;
      font-weight: 500;
      font-size: 25px;
    }
    b {
      color: #333;
      font-weight: 400;
      font-size: 25px;
    }
    b.active {
      color: #ff6c02;
      font-size: 33px;
    }
  }
}
.pay-flow {
  width: 100%;
  margin: 22px 0;
  padding: 36px 36px 16px 36px;
  background: #fff;
  border-radius: 14px;
  h3 {
    padding-bottom: 25px;
    color: #333;
    font-weight: 600;
    font-size: 25px;
  }
  .time-flow,
  .time-flow1 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 10px;
    padding-bottom: 34px;
    border-left: 2px dotted #a5a5a5;
    .time-flow-box {
      position: relative;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      padding-left: 20px;
      .icon {
        position: absolute;
        top: -3px;
        left: -15px;
        width: 29px;
        height: 29px;
        background: url('../../../assets/img/personalImg/icon-price.png') #fff no-repeat;
        background-size: 100%;
      }
      img {
        position: absolute;
        top: -4px;
        left: -15px;
        width: 29px;
        height: 29px;
        background: #fff;
      }
      span {
        color: #ff6c02;
        font-weight: 500;
        font-size: 25px;
        b {
          color: #ff6c02;
          font-weight: 400;
          font-size: 25px;
        }
      }
    }
    b {
      color: #ff6c02;
      font-weight: normal;
      font-size: 33px;
    }
    .order-time {
      position: absolute;
      top: 20px;
      left: 17px;
      display: none;
      width: 580px;
      span,
      b {
        color: #a39595 !important;
        font-size: 22px;
      }
      b {
        float: right;
        padding-top: 20px;
      }
    }
  }
  .time-flow1 {
    border-left: none;
    .time-flow-box {
      .icon {
        position: absolute;
        top: -2px;
        left: -15px;
        width: 29px;
        height: 29px;
        background: url('../../../assets/img/personalImg/icon-dot.png') #fff no-repeat;
        background-size: 100%;
      }
      span {
        color: #333;
        b {
          color: #787878;
        }
      }
    }
    b {
      color: #333;
      font-weight: 600;
      font-size: 25px;
    }
  }
}
.order-info {
  width: 100%;
  margin: 22px 0;
  padding: 29px 36px 16px 36px;
  background: #fff;
  border-radius: 14px;
  .order-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 25px;
    span {
      color: #333;
      font-weight: 500;
      font-size: 25px;
    }
    div {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    b {
      padding-right: 7px;
      color: #787878;
      font-weight: 400;
      font-size: 25px;
    }
    img {
      width: 43px;
      height: 43px;
    }
  }
}
.btns {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 89px;
  padding-top: 14px;
  background: #fefffe;
  box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);
  .btns-box {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 89px;
    padding-right: 36px;
    button {
      width: 187px;
      height: 63px;
      font-size: 25px;
      border-radius: 32px;
    }
    .cancel {
      color: #787878;
      font-weight: 400;
      background: none;
    }
    .pay {
      color: #fff;
      font-weight: 500;
      background: #ff6c02;
    }
  }
}
.handsel-detail.deposit {
  // 定金UI
  .pay-flow {
    .time-flow,
    .time-flow1 {
      padding-bottom: 67px;
      .time-flow-box {
        .icon {
          position: absolute;
          top: -4px;
          left: -15px;
          width: 29px;
          height: 29px;
          background: url('../../../assets/img/personalImg/checked.png') #fff no-repeat;
          background-size: 100%;
        }
        span {
          color: #333;
          b {
            color: #787878;
          }
        }
      }
      b {
        color: #333;
        font-size: 25px;
      }
      .order-time {
        display: inline-block;
      }
    }
    .time-flow1 {
      padding-bottom: 34px;
      border-left: none;
      .time-flow-box {
        .icon {
          position: absolute;
          top: -2px;
          left: -15px;
          width: 29px;
          height: 29px;
          background: url('../../../assets/img/personalImg/icon-price.png') #fff no-repeat;
          background-size: 100%;
        }
        span {
          color: #ff6c02;
          b {
            color: #ff6c02;
            font-weight: normal;
            font-size: 22px;
          }
        }
      }
      b {
        color: #ff6c02;
        font-weight: 600;
        font-size: 33px;
      }
    }
  }
}
</style>
